// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUsernameRegistrationVerifyRequestDto
 */
export interface IUsernameRegistrationVerifyRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IUsernameRegistrationVerifyRequestDto
     */
    username: string;
    /**
     * 
     * @type {Date}
     * @memberof IUsernameRegistrationVerifyRequestDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IUsernameRegistrationVerifyRequestDto
     */
    unique_id: string;
}

/**
 * Check if a given object implements the IUsernameRegistrationVerifyRequestDto interface.
 */
export function instanceOfIUsernameRegistrationVerifyRequestDto(value: object): value is IUsernameRegistrationVerifyRequestDto {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('unique_id' in value) || value['unique_id'] === undefined) return false;
    return true;
}

export function IUsernameRegistrationVerifyRequestDtoFromJSON(json: any): IUsernameRegistrationVerifyRequestDto {
    return IUsernameRegistrationVerifyRequestDtoFromJSONTyped(json, false);
}

export function IUsernameRegistrationVerifyRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUsernameRegistrationVerifyRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'unique_id': json['unique_id'],
    };
}

export function IUsernameRegistrationVerifyRequestDtoToJSON(json: any): IUsernameRegistrationVerifyRequestDto {
    return IUsernameRegistrationVerifyRequestDtoToJSONTyped(json, false);
}

export function IUsernameRegistrationVerifyRequestDtoToJSONTyped(value?: IUsernameRegistrationVerifyRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'unique_id': value['unique_id'],
    };
}

